import { useEffect } from 'react';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';

import { toI18n } from 'util/i18n';
import {
  ELEMENTS,
  EVENT_ACTIONS,
  EVENT_CATEGORIES,
  PRODUCT_AREAS,
  TRACK_ACTION_TYPES,
} from 'util/tracking_constants';
import { useTrackUx, withUxRoot } from 'util/uxEvents';

function NoBoostModal() {
  const trackUx = useTrackUx();

  useEffect(() => {
    trackUx(EVENT_ACTIONS.MODAL_VIEWED, TRACK_ACTION_TYPES.VIEW, {
      element: ELEMENTS.PREMIUM_BOOST_NOT_AVAILABLE_MODAL,
    });
  }, [trackUx]);

  return (
    <Box flex column gap={16} maxw={450}>
      <Text color="mono900">
        {toI18n('hiring.premium_boosts_not_available_yet.desc')}
      </Text>
      <Text color="primary500">
        {toI18n(
          'hiring.premium_boosts_not_available_yet.what_are_premium_boosts'
        )}
      </Text>
      <Text color="mono700" asHTML>
        {toI18n('hiring.premium_boosts_not_available_yet.craigslist')}
      </Text>
      <Text color="mono700" asHTML>
        {toI18n('hiring.premium_boosts_not_available_yet.zip_recruiter')}
      </Text>
    </Box>
  );
}

export default withUxRoot({
  productArea: PRODUCT_AREAS.HIRING,
  eventCategory: EVENT_CATEGORIES.HIRING_JOBS,
})(NoBoostModal);
